module.exports = "/images/oculus-6.jpg";